import React, {Component} from 'react';
import GoogleMapReact from 'google-map-react';
import {MAP_API_KEY} from "./../../config/Config";

const Marker = ({ text }) => <div className="my-map-marker"><span>{text}</span></div>;

export default class MapContainer extends Component {
    static defaultProps = {
        center: {
            lat: 32.6424311,
            lng: 51.6746248
        },
        zoom: 14
    };
    render() {
        return (
            <div style={{ height: '615px', width: '100%' }}>
                <GoogleMapReact
                    bootstrapURLKeys={{ key: MAP_API_KEY }}
                    defaultCenter={this.props.center}
                    defaultZoom={this.props.zoom}
                >
                    <Marker
                        lat={32.6424011}
                        lng={51.6751148}
                        text={'iranroute'}
                    />
                </GoogleMapReact>



            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/map/ContactMap.js